import { validatePresence } from "ember-changeset-validations/validators";

export default {
  nationalMedicId: validatePresence({
    presence: true,
    description: "Le numéro RPPS/ADELI"
  })
};
